import type { WorldBuilderResult } from '@creanizer/types'

interface WorldMagicSystemProps {
  magicSystem?: WorldBuilderResult['details']['magicSystem']
}

export function WorldMagicSystem({ magicSystem }: WorldMagicSystemProps) {
  if (!magicSystem || !magicSystem.exists) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        この世界には魔法体系が存在しません
      </div>
    )
  }
  
  return (
    <div className="space-y-4">
      <div>
        <h3 className="font-semibold mb-2">概要</h3>
        <p className="text-sm text-muted-foreground">{magicSystem.description}</p>
      </div>
      
      {magicSystem.rules && magicSystem.rules.length > 0 && (
        <div>
          <h4 className="text-sm font-semibold mb-2">魔法のルール</h4>
          <ul className="space-y-2">
            {magicSystem.rules.map((rule, index) => {
              const isObject = typeof rule === 'object' && rule !== null
              return (
                <li key={index} className="flex items-start gap-2">
                  <span className="text-primary mt-1">▸</span>
                  {isObject ? (
                    <div className="flex-1">
                      <div className="text-sm font-medium text-primary">
                        {(rule as any).name}
                      </div>
                      <div className="text-xs text-muted-foreground mt-1">
                        {(rule as any).description}
                      </div>
                    </div>
                  ) : (
                    <span className="text-sm">{String(rule)}</span>
                  )}
                </li>
              )
            })}
          </ul>
        </div>
      )}
      
      {magicSystem.limitations && magicSystem.limitations.length > 0 && (
        <div>
          <h4 className="text-sm font-semibold mb-2">制限事項</h4>
          <ul className="space-y-2">
            {magicSystem.limitations.map((limitation, index) => {
              const isObject = typeof limitation === 'object' && limitation !== null
              return (
                <li key={index} className="flex items-start gap-2">
                  <span className="text-red-500 mt-1">⚠</span>
                  {isObject ? (
                    <div className="flex-1">
                      <div className="text-sm font-medium text-red-700">
                        {(limitation as any).name}
                      </div>
                      <div className="text-xs text-muted-foreground mt-1">
                        {(limitation as any).description}
                      </div>
                    </div>
                  ) : (
                    <span className="text-sm text-muted-foreground">{String(limitation)}</span>
                  )}
                </li>
              )
            })}
          </ul>
        </div>
      )}
      
      {magicSystem.practitioners && magicSystem.practitioners.length > 0 && (
        <div>
          <h4 className="text-sm font-semibold mb-2">魔法使いの種類</h4>
          <div className="flex flex-wrap gap-2">
            {magicSystem.practitioners.map((practitioner, index) => {
              const isObject = typeof practitioner === 'object' && practitioner !== null
              return (
                <div
                  key={index}
                  className="px-3 py-1 bg-purple-100 rounded-full"
                >
                  {isObject ? (
                    <div>
                      <div className="text-sm font-medium text-purple-700">
                        {(practitioner as any).name}
                      </div>
                      {(practitioner as any).description && (
                        <div className="text-xs text-purple-600 mt-0.5">
                          {(practitioner as any).description}
                        </div>
                      )}
                    </div>
                  ) : (
                    <span className="text-sm text-purple-700">{String(practitioner)}</span>
                  )}
                </div>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}